/* Fuego & Fragancia — texto que aparece como una máquina de escribir.

   Decisiones que importan:

   · El texto completo ya está en el DOM desde el principio; lo único que se
     anima es la opacidad de cada letra. Así Google y los lectores de pantalla
     leen la frase entera, y NO hay salto de maquetación al terminar (el hueco
     que ocupará el texto ya está reservado).

   · Los espacios se dejan como nodos de texto sueltos, sin envolver. Son los
     puntos donde el navegador puede partir la línea: si se metieran dentro de
     un <span> el texto se repartiría distinto y la frase cambiaría de forma.

   · Arranca al entrar en pantalla, no al cargar la página: si no, la
     animación se la pierde quien todavía no ha llegado a esa altura. */

if (!customElements.get('ff-typewriter')) {
  customElements.define(
    'ff-typewriter',
    class FfTypewriter extends HTMLElement {
      connectedCallback() {
        if (this.prepared) return;
        this.prepared = true;

        this.speed = parseFloat(this.dataset.speed) || 55; // letras por segundo

        // Si el visitante pide menos animaciones, se muestra ya escrito.
        if (
          this.dataset.respectReduced === 'true' &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          return;
        }

        this.letters = this.split();
        if (!this.letters.length) return;

        this.classList.add('is-typing');

        const start = () => {
          if (this.started) return;
          this.started = true;
          this.run();
        };

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                start();
                this.observer.disconnect();
              });
            },
            // 25%: espera a que la frase esté claramente a la vista, no en
            // cuanto asoma un píxel por el borde inferior.
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        } else {
          start();
        }
      }

      // Envuelve cada carácter visible en un <span>, dejando los espacios como
      // texto normal para no alterar dónde se parten las líneas.
      split() {
        const text = this.textContent;
        const frag = document.createDocumentFragment();
        const letters = [];

        for (const char of text) {
          if (char === ' ' || char === '\n' || char === '\t') {
            frag.appendChild(document.createTextNode(char));
            continue;
          }
          const span = document.createElement('span');
          span.className = 'ff-type__c';
          span.textContent = char;
          frag.appendChild(span);
          letters.push(span);
        }

        this.textContent = '';
        this.appendChild(frag);
        return letters;
      }

      run() {
        const total = this.letters.length;
        let shown = 0;
        let last = null;

        const tick = (now) => {
          if (last === null) last = now;
          const elapsed = (now - last) / 1000;
          // Se calcula cuántas letras tocan por tiempo transcurrido, no una por
          // fotograma: así la velocidad es la misma en pantallas de 60 y 120 Hz.
          const target = Math.min(total, Math.floor(elapsed * this.speed));

          while (shown < target) {
            this.letters[shown].classList.add('is-on');
            shown += 1;
          }

          if (shown < total) {
            requestAnimationFrame(tick);
          } else {
            this.classList.remove('is-typing');
            this.classList.add('is-done');
          }
        };

        requestAnimationFrame(tick);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
